import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";

export default function Form() {
  const [sent, setSent] = useState(false);
  const form = useRef();

  // let captcha;

  const sendEmail = (e) => {
    e.preventDefault();
    setSent(true);
    emailjs
      .sendForm(
        "service_0mqq41n",
        "template_7trc14m",
        form.current,
        "user_2BpYPep4LwwZJtdVYzpmD"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.error(error.text);
        }
      );
  }
  // function onFormSubmit(e) {
  //   e.preventDefault();
  //   window.grecaptcha.ready(function() {
  //     window.grecaptcha.execute('6LdcNN0cAAAAAPDnEzJi2E_SLJ2VsDn0TwTeqqdH', {action: 'submit'}).then(function(token) {
  //       // Send form value as well as token to the server
  //     });
  //   });
  // }

  return (
    <form className="col-md-4 mb-5 center" ref={form} onSubmit={sendEmail} onChange={() => setSent(false)}>
      <input
        type="text"
        placeholder="Full name*"
        name="from_name"
        required
      />
      <input type="email" placeholder="Email*" name="from_email" required />
      <textarea name="message" placeholder="Message*" rows="6" required />
      <input
          type="submit"
          value={sent ? "Success! Talk to you soon." : "Submit"}
          className="contact-form-submit"
          id={sent ? "sent" : "not-sent"}
        />
      {/* <button
        data-action='submit'
        className="contact-form-submit"
        onClick={e => onFormSubmit(e)}
      >Submit</button> */}
    </form>
  )
}